// extracted by mini-css-extract-plugin
export default {"retweetbtn":"Retweet_retweetbtn__lljlp"};